module.exports = __webpack_public_path__ + "img/bg-zip.fa0b956d.png";